export interface AddJournalEntryEvent {
  entryText: string;
  styleId: number;
}
